import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Subject, firstValueFrom } from "rxjs";
import { ENVIRONMENT } from "../../environments/environment";
import { IQuickscanData } from "../../types/quickscan";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  public quickScans: IQuickscanData[];
  public quickScansChanged: Subject<boolean>;
  public customers$: BehaviorSubject<string[]>;

  private http: HttpClient;

  public constructor() {
    this.quickScans = [];
    this.quickScansChanged = new Subject();
    this.customers$ = new BehaviorSubject<string[]>([]);

    this.http = inject(HttpClient);
  }

  /** Retrieve Customers which will be used for  */
  public async getCustomers(): Promise<void> {
    const customers = await firstValueFrom(this.http.get<string[]>(`${ENVIRONMENT.API}getQuickscanCustomers`));
    this.customers$.next(customers);
  }

  /** Retrieve QuickScans and emit them to parent component */
  public async getFilteredQuickScans(formGroupValue: Record<string, unknown> = {}): Promise<void> {
    const quickscans = await firstValueFrom(this.http.post<IQuickscanData[]>(`${ENVIRONMENT.API}getQuickscans`, formGroupValue));
    // const quickscans: any = await firstValueFrom(this.http.get(url, options));
    this.quickScans = quickscans;
    this.quickScansChanged.next(true);
  }
}
